import styled, { css } from 'styled-components';

import ActionButton from 'components/action-button';
import IconClose from 'components/icons/close';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import Picture from 'components/picture';

export const ButtonsContainer = styled.div`
  width: 100%;
`;

export const CloseButton = styled(IconClose)`
  height: 24px;
  margin: 16px 12px;
  position: absolute;
  z-index: 1;
  cursor: pointer;
  ${Styles.desktop`
    height: 32px;
    margin: 0;
    top: 32px;
    left: 23px;
  `}
`;

const CenterAligned = css`
  align-items: center;
  display: flex;
`;

export const Header = styled.div`
  ${CenterAligned}
  flex-direction: column;
  justify-content: space-around;
  font-family: ${Styles.fontFamily.brand};
  text-align: center;
  span {
    font-family: ${Styles.fontFamily.body};
  }
  * {
    margin-bottom: 0.5rem;
  }
`;

export const Container = styled.div`
  padding: 16px 24px 16px 24px;
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${Styles.color.black};
  ${Styles.desktop`
    padding: 32px;
  `}
`;

export const ItemImage = styled(Picture)`
  margin: 0 16px 0 0;
`;

export const MainTitle = styled.h1`
  font-family: ${Styles.fontFamily.brand};
  font-size: 1.5rem;
  line-height: 1.5rem;
  margin-top: 0;
`;

export const NoThanks = styled.button`
  background: transparent;
  border: 0;
  cursor: pointer;
  font-family: ${Styles.fontFamily.body};
  font-size: 0.9375rem;
  letter-spacing: normal;
  text-decoration: none;
  width: 100%;
`;

export const UpsizeButton = styled(ActionButton)`
  margin-bottom: 16px;
  width: 100%;
  background-color: ${Styles.color.black};
  ${Styles.desktop`
    width: 380px;
  `}
`;

export const SingleItem = styled.div`
  ${CenterAligned}
  width: 10rem;
  border-bottom: solid 1px ${Styles.color.grey.four};
  cursor: pointer;
  justify-content: space-between;
  padding: 0.875rem 1.25rem 1.125rem;

  border: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 12px;

  :last-of-type {
    border-bottom: 0;
  }

  span {
    border-radius: 50%;
  }

  &.selected {
    border: 2px solid ${Styles.color.alert.info.background};
    background: rgba(255, 135, 50, 0.1);
    box-shadow: none;
  }
`;

export const SingleItemContent = styled.div`
  ${CenterAligned}
  flex-direction: column;
  text-align: center;
  align-items: stretch;

  h4 {
    font-family: ${Styles.fontFamily.brand};
    font-size: 1rem;
    margin: 0;
  }

  p {
    font-size: 0.8125rem;
    margin: 0;
  }
`;

export const StyledPointsIcon = styled(LoyaltyPointsIcon)`
  width: 48px;
  height: 48px;
`;
